import type { FC } from 'react'
import type { SvgIconProps } from '@mui/material'
import { Delete, PauseCircleFilled, Replay, ToggleOn } from '@mui/icons-material'

import type { ReadonlyRecord } from '../../../../utils'

import { Translation } from '../../../../domain'

import type { ActionName } from './Types'

/** Shared by the toolbar's bulk actions and the rows' action menus, so both offer the same actions the same way */
export const ACTION_ORDER: readonly ActionName[] = ['ENABLE', 'DISABLE', 'DELETE', 'RESTART']
export const defaultIcons: ReadonlyRecord<ActionName, FC<SvgIconProps>> = { DELETE: Delete, DISABLE: PauseCircleFilled, ENABLE: ToggleOn, RESTART: Replay }
export const defaultTranslations: ReadonlyRecord<ActionName, Translation> = {
    DELETE: Translation.DELETE,
    DISABLE: Translation.DISABLE,
    ENABLE: Translation.ENABLE,
    RESTART: Translation.RESTART,
}
export const DESTRUCTIVE_ACTION: ActionName = 'DELETE'
